module.exports = __webpack_public_path__ + "static/media/BDD_SetUpScreens_Profile.199be728.png";